import React, { useState } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { Button, Image, Col, Row, Table } from "react-bootstrap";
import moment from "moment";
import { useHistory } from "react-router";
import { PopupActionButton } from "../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import MobileVendorEditOfflineEvent from "./EditEvent/MobileVendorEditOfflineEvent";
import { AuditLogsheaderTable } from "../../reusableComponents/allTableReusable/auditLogTable/AuditLogsheaderTable";
import { AuditLogsBodyTable } from "../../reusableComponents/allTableReusable/auditLogTable/AuditLogsBodyTable";
import isEmpty from "../../../store/validation/is-Empty";
import { Toggle } from "../../superAdminComponents/superAdminReusable/reusableSuperAdminButton/Toggle";
import SuperAdminDeleteEvent from "../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/SuperAdminDeleteEvent";
import SimpleReactLightbox from "simple-react-lightbox";
import { SRLWrapper } from "simple-react-lightbox";
import { VideoOptions } from "../../../config/Keys";

const MobileViewEventDetailsOffline = (props) => {
  const history = useHistory();
  //state
  const [selectedTab, setSelectedTab] = useState("1");
  const [state, setState] = useState({
    open: false,
  });
  const [checked, setChecked] = useState(false);
  const [showView, setShowView] = useState(false);
  const toggleFunction = (e) => {
    // setChecked({ checked: !checked.checked });
    // console.log("test");
  };
  const handleTab = (e) => {
    setSelectedTab(e);
  };
  const [showLog, setShowLog] = useState(false);
  const handleShowLog = () => {
    setShowLog(!showLog);
  };

  const onOpenModal = () => {
    setState({
      open: true,
    });
  };
  const onCloseModal = () => {
    setState({
      open: false,
    });
  };
  const handleShowView = () => {
    setShowView(true);
  };

  const handleCloseView = () => setShowView(false);
  const renderAuditViewDetails = () => {
    if (!isEmpty(props.vendorEvent.auditLogs)) {
      return props.vendorEvent.auditLogs.map((data, index) => (
        <React.Fragment key={index}>
          <AuditLogsBodyTable
            date={moment(data.timestamp).format("Do MMM, YYYY")}
            time={moment(data.timestamp).format("hh:mm A")}
            message={data.message}
            by={data.initiator}
          />
        </React.Fragment>
      ));
    }
  };

  const editOfflineEvent = (data) => {
    history.push({
      pathname: `/event/edit-offline-event`,
      state: { editData: data },
    });
  };

  const editOnlineEvent = (data) => {
    history.push({
      pathname: `/event/edit-online-event`,
      state: { editData: data },
    });
  };

  return (
    <>
      <React.Fragment>
        {props.mobileButton ? (
          <PopupActionButton
            buttonText={"View"}
            buttonType="button"
            buttonClass="smallblue"
            onClick={onOpenModal}
          />
        ) : (
          <div className="enIconBtn mr-3" onClick={onOpenModal}>
            <Image
              src={require("../../../assets/images/UserManagement/eye.svg")}
              alt="Edit"
              title="Edit"
              fluid
            />
          </div>
        )}
        <Modal
          open={state.open}
          onClose={onCloseModal}
          center
          classNames={{
            overlay: "customOverlay-request-accept-cancelled",
            modal: "offer-event-main closeRemove min-height-100vh w-100",
            animationIn: "customEnterAnimation",
            animationOut: "customLeaveAnimation",
          }}
          animationDuration={1000}
        >
          <div className="d-flex align-items-center py-3 px-4 border-bottom">
            <span className="pr-3 cursor" onClick={onCloseModal}>
              <Image
                alt="Back"
                width="20px"
                src={require("../../../assets/images/UserManagement/backIcon.svg")}
              />
            </span>
            <div className="f12-400 c_black">View Event</div>
          </div>
          <div class="nav-scroller py-1 h-auto px-3 border-bottom ">
            <div className="nav d-flex align-items-center py-2">
              <Button
                variant="link"
                onClick={(e) => handleTab("1")}
                className={`px-0 mr-4 text-grayLink f12-500 ${
                  selectedTab === "1" ? "active" : ""
                }`}
              >
                General Information
              </Button>
              <Button
                variant="link"
                onClick={(e) => handleTab("2")}
                className={`px-0 mr-4 text-grayLink f12-500 ${
                  selectedTab === "2" ? "active" : ""
                }`}
              >
                RSVP
              </Button>
              <Button
                variant="link"
                onClick={(e) => handleTab("3")}
                className={`px-0 mr-4 text-grayLink f12-500 ${
                  selectedTab === "3" ? "active" : ""
                }`}
              >
                Ticket Booking
              </Button>
              <Button
                variant="link"
                onClick={(e) => handleTab("4")}
                className={`px-0 mr-4 text-grayLink f12-500 ${
                  selectedTab === "4" ? "active" : ""
                }`}
              >
                Seating
              </Button>
              <Button
                variant="link"
                onClick={(e) => handleTab("5")}
                className={`px-0 mr-4 text-grayLink f12-500 ${
                  selectedTab === "5" ? "active" : ""
                }`}
              >
                Other Settings
              </Button>
            </div>
          </div>
          <div className="col-12 py-3">
            <div className="f12-400 opacity5">Event Name</div>
            <div className="d-flex align-items-center pt-2 pb-3">
              <div className="f16-500">
                {props.vendorEvent && props.vendorEvent.name}
              </div>
              <div className="enPendingLBL ml-2">Offline</div>
            </div>
            <div className="f12-400 opacity5">Description</div>
            <div className="pt-2 f12-400">
              {props.vendorEvent && props.vendorEvent.description}
            </div>
            <div className="d-flex pt-3">
              <div
                className="enIconBtn mr-3"
                onClick={(e) =>
                  props.vendorEvent && props.vendorEvent.isOnline
                    ? editOnlineEvent(props.vendorEvent)
                    : editOfflineEvent(props.vendorEvent)
                }
              >
                <Image
                  src={require("../../../assets/images/UserManagement/pencil.svg")}
                  alt="Edit"
                  title="Edit"
                  fluid
                />
              </div>
              {/* <MobileVendorEditOfflineEvent data={props.data} /> */}
              <SuperAdminDeleteEvent
                handleCloseView={handleCloseView}
                actionBy={"vendor"}
                insideDelete={"viewDelete"}
                eventId={props.vendorEvent && props.vendorEvent._id}
              />
            </div>
          </div>
          {selectedTab === "1" && (
            <React.Fragment>
              <Row className="mx-0">
                <Col xs={6} className="py-3 border-top border-right">
                  <div className="pb-2 f12-400 opacity5">Status</div>
                  <div className="d-flex align-items-center">
                    <div className="f12-500 mr-2">Inactive</div>
                    <Toggle
                      checked={props.vendorEvent && props.vendorEvent.active}
                      toggleFunction={toggleFunction}
                    />
                  </div>
                </Col>
                <Col xs={6} className="py-3 border-top">
                  <div className="pb-2 f12-400 opacity5">Primary Status</div>
                  <div className="d-flex align-items-center">
                    <div className="f12-500 mr-2">No</div>
                    <Toggle
                      checked={
                        props.vendorEvent && props.vendorEvent.mark_as_primary
                      }
                      toggleFunction={toggleFunction}
                    />
                    <div className="f12-500 ml-2">Yes</div>
                  </div>
                </Col>
                <Col xs={6} className="py-3 border-top border-right">
                  <div className="pb-2 f12-400 opacity5">Kids Allowed</div>
                  <div className="d-flex align-items-center">
                    <div className="f12-500 mr-2">No</div>
                    <Toggle
                      checked={
                        props.vendorEvent && props.vendorEvent.mark_as_primary
                      }
                      toggleFunction={toggleFunction}
                    />
                    <div className="f12-500 ml-2">Yes</div>
                  </div>
                </Col>
                <Col xs={6} className="py-3 border-top">
                  <div className="pb-2 f12-400 opacity5">Event Tags</div>
                  <div className="f14-400 mr-2">
                    {props?.vendorEvent?.eventTags.map((data, index) => {
                      if (index + 1 === props?.vendorEvent?.eventTags.length)
                        return `${data}`;
                      else return `${data},`;
                    })}
                  </div>
                </Col>
                <Col xs={6} className="py-3 border-top border-right">
                  <div className="pb-2 f12-400 opacity5">Start Date</div>
                  <div className="d-flex align-items-center">
                    <Image
                      src={require("../../../assets/images/UserManagement/calendar.svg")}
                      alt="View"
                      title="View"
                      width="20px"
                      className="mr-2"
                    />
                    <div className="f14-500 ">
                      {" "}
                      {moment(
                        props.vendorEvent && props.vendorEvent.start_date
                      ).format("DD/MM/YYYY")}
                    </div>
                  </div>
                </Col>
                <Col xs={6} className="py-3 border-top">
                  <div className="pb-2 f12-400 opacity5">Start Time</div>
                  <div className="d-flex align-items-center">
                    <div className="f14-500 ">
                      {" "}
                      {moment(
                        props.vendorEvent && props.vendorEvent.start_date
                      ).format("hh:mm A")}
                    </div>
                  </div>
                </Col>
                <Col xs={6} className="py-3 border-top border-right">
                  <div className="pb-2 f12-400 opacity5">End Date</div>
                  <div className="d-flex align-items-center">
                    <Image
                      src={require("../../../assets/images/UserManagement/calendar.svg")}
                      alt="View"
                      title="View"
                      width="20px"
                      className="mr-2"
                    />
                    <div className="f14-500 ">
                      {" "}
                      {moment(
                        props.vendorEvent && props.vendorEvent.end_date
                      ).format("DD/MM/YYYY")}
                    </div>
                  </div>
                </Col>
                <Col xs={6} className="py-3 border-top">
                  <div className="pb-2 f12-400 opacity5">End Time</div>
                  <div className="d-flex align-items-center">
                    <div className="f14-500 ">
                      {" "}
                      {moment(
                        props.vendorEvent && props.vendorEvent.end_date
                      ).format("hh:mm A")}
                    </div>
                  </div>
                </Col>
                <Col xs={12} className="py-3 border-top">
                  <div className="pb-2 f12-400 opacity5">
                    Venue /Address / Location
                  </div>
                  <div className="f12-400">
                    {props.vendorEvent && props.vendorEvent.venue_address}
                  </div>
                  <div className="pt-2 pb-4 f12-400"></div>
                </Col>
                <Col xs={12} className="py-3 border-top">
                  <div className="pb-4">
                    <div className="pb-2 f12-400 opacity5">
                      View Event Image
                    </div>
                    <div className="enIMG105">
                      <Image
                        src={
                          props.vendorEvent &&
                          props.vendorEvent.photos &&
                          props.vendorEvent.photos[0]
                        }
                        alt="offer"
                        title="offer"
                        fluid
                        className="w-100 h-100"
                      />
                    </div>
                    <div className="pt-2 f12-400">
                      (You can upload only 1 pic per offer 700 x 420 pixels)
                    </div>
                  </div>
                  <div className="pb-4">
                    <div className="pb-2 f12-400 opacity5">View Video</div>
                    {props?.vendorEvent?.videos?.length > 0 && (
                      <div className="w-25">
                        <SimpleReactLightbox>
                          <SRLWrapper options={VideoOptions}>
                            <video width="100%" height="100%" controls>
                              <source
                                src={
                                  props?.vendorEvent &&
                                  props?.vendorEvent?.videos &&
                                  props?.vendorEvent?.videos[0]
                                }
                                type="video/mp4"
                              />
                            </video>
                          </SRLWrapper>
                        </SimpleReactLightbox>
                      </div>
                    )}
                  </div>
                </Col>
                <Col xs={12} className="py-3 border-top">
                  <div className="f12-400 opacity5">Terms and Conditions</div>
                  <div className="pt-2 f12-400">
                    {props.vendorEvent && props.vendorEvent.terms_and_condition}
                  </div>
                </Col>
              </Row>
            </React.Fragment>
          )}
          {selectedTab === "2" && (
            <React.Fragment>
              <Row className="mx-0">
                <Col xs={5} className="py-3 border-top border-right">
                  <div className="pb-2 f12-400 opacity5">Auto Accept</div>
                  <div className="d-flex align-items-center">
                    <div className="f12-400 mr-2">No</div>
                    <Toggle
                      checked={checked.checked}
                      toggleFunction={toggleFunction}
                    />
                    <div className="f12-400 ml-2">Yes</div>
                  </div>
                </Col>
                <Col xs={7} className="py-3 border-top">
                  <div className="pb-2 f12-400 opacity5">
                    Maximum Number of Guests
                  </div>
                  <div className="f14-500">
                    {props.vendorEvent?.maxGuest_RSVP || 0}
                  </div>
                </Col>
                <Col xs={12} className="py-3 border-top">
                  <div className="pb-2 f12-400 opacity5">Buffer</div>
                  <div className="f14-500">
                    {props.vendorEvent?.buffer_RSVP_guest || 0}
                  </div>
                </Col>
              </Row>
            </React.Fragment>
          )}
          {selectedTab === "3" && (
            <React.Fragment>
              <Row className="mx-0">
                <Col xs={6} className="py-3 border-top border-right">
                  <div className="pb-2 f12-400 opacity5">Ticket Name</div>
                  <div className="f14-500">
                    {props.vendorEvent?.ticketName || ""}
                  </div>
                </Col>
                <Col xs={6} className="py-3 border-top">
                  <div className="pb-2 f12-400 opacity5">Ticket Type</div>
                  <div className="f14-500">-</div>
                </Col>
              </Row>
              <Row className="mx-0">
                <Col xs={4} className="py-3 border-top border-right">
                  <div className="pb-2 f12-400 opacity5">Adult Price</div>
                  <div className="f14-500">
                    {props.vendorEvent?.adult_price || 0}
                  </div>
                </Col>
                <Col xs={4} className="py-3 border-top  border-right">
                  <div className="pb-2 f12-400 opacity5">Child Price</div>
                  <div className="f14-500">
                    {props.vendorEvent?.child_price || 0}
                  </div>
                </Col>
                <Col xs={4} className="py-3 border-top">
                  <div className="pb-2 f12-400 opacity5">Total Quantity</div>
                  <div className="f14-500">
                    {props.vendorEvent?.total_quantity_TB || 0}
                  </div>
                </Col>
              </Row>
              <Row className="mx-0">
                <Col xs={6} className="py-3 border-top border-right">
                  <div className="pb-2 f12-400 opacity5">
                    Minimum people per booking
                  </div>
                  <div className="f14-500">
                    {props.vendorEvent?.min_people_per_booking || 0}
                  </div>
                </Col>
                <Col xs={6} className="py-3 border-top">
                  <div className="pb-2 f12-400 opacity5">
                    Maximum people per booking
                  </div>
                  <div className="f14-500">
                    {props.vendorEvent?.max_people_per_booking || 0}
                  </div>
                </Col>
                <Col xs={12} className="py-3 border-top">
                  <div className="pb-2 f12-400 opacity5">
                    Ticket Description
                  </div>
                  <div className="f12-400">
                    {props.vendorEvent?.ticket_description || ""}
                  </div>
                </Col>
              </Row>
            </React.Fragment>
          )}
          {selectedTab === "4" && (
            <React.Fragment>
              <Row className="mx-0">
                <Col xs={6} className="py-3 border-top border-right">
                  <div className="pb-2 f12-400 opacity5">
                    Floor Number / Seating Area
                  </div>
                  <div className="f14-500">First Floor</div>
                </Col>
                <Col xs={6} className="py-3 border-top">
                  <div className="pb-2 f12-400 opacity5">
                    Section Name/Number
                  </div>
                  <div className="f14-500">13 A</div>
                </Col>
                <Col xs={6} className="py-3 border-top border-right">
                  <div className="pb-2 f12-400 opacity5">
                    Floor Number / Seating Area
                  </div>
                  <div className="f14-500">Second Floor</div>
                </Col>
                <Col xs={6} className="py-3 border-top">
                  <div className="pb-2 f12-400 opacity5">
                    Section Name/Number
                  </div>
                  <div className="f14-500">13 B</div>
                </Col>
                <Col xs={12} className="py-3 border-top">
                  <button
                    className={
                      "add-button-icon-reusable add-button-icon-reusable-blue"
                    }
                  >
                    View seating map
                  </button>
                </Col>
              </Row>
            </React.Fragment>
          )}
          {selectedTab === "5" && (
            <React.Fragment>
              <Row className="mx-0">
                <Col xs={6} className="py-3 border-top border-right">
                  <div className="pb-2 f12-400 opacity5">Highchair</div>
                  <div className="f14-500">
                    {props.vendorEvent && props.vendorEvent.highchair
                      ? "Yes"
                      : "No"}
                  </div>
                </Col>
                <Col xs={6} className="py-3 border-top">
                  <div className="pb-2 f12-400 opacity5">Handicap Access</div>
                  <div className="f14-500">
                    {props.vendorEvent && props.vendorEvent.handicap_access
                      ? "Yes"
                      : "No"}
                  </div>
                </Col>
                <Col xs={6} className="py-3 border-top border-right">
                  <div className="pb-2 f12-400 opacity5">
                    Room number on Seating Request?
                  </div>
                  <div className="f14-500">
                    {props.vendorEvent && props.vendorEvent.room_on_seating_rq
                      ? "Yes"
                      : "No"}
                  </div>
                </Col>
                <Col xs={6} className="py-3 border-top">
                  <div className="pb-2 f12-400 opacity5">
                    Auto Accept Pax Limit
                  </div>
                  <div className="f14-500">
                    {props.vendorEvent && props.vendorEvent.auto_accept_pax}
                  </div>
                </Col>
              </Row>
            </React.Fragment>
          )}
          <div className="sectionHeader f12-700">More Details</div>
          <div className="d-flex border-bottom">
            <div className="col-6 py-3">
              <div className="f10-400 opacity5 pb-2">Event ID</div>
              <div className="f12-500 c_black text-break">
                #{props.vendorEvent && props.vendorEvent._id}
              </div>
            </div>
            <div className="col-6 py-3">
              <div className="f10-400 opacity5 pb-2">Changed Date / Time</div>
              <div className="f12-500 c_black">
                {" "}
                {moment(
                  props.vendorEvent && props.vendorEvent.updatedAt
                ).format("Do MMM, YYYY")}
              </div>
              <div className="f12-500 c_black">
                {" "}
                {moment(
                  props.vendorEvent && props.vendorEvent.updatedAt
                ).format("hh:mm A")}
              </div>
            </div>
          </div>
          <div className="d-flex border-bottom">
            <div className="col-6 py-3">
              <div className="f10-400 opacity5 pb-2">Created Date / Time</div>
              <div className="f12-500 c_black">
                {moment(
                  props.vendorEvent && props.vendorEvent.createdAt
                ).format("Do MMM, YYYY")}
              </div>
              <div className="f12-500 c_black">
                {moment(
                  props.vendorEvent && props.vendorEvent.createdAt
                ).format("hh:mm A")}
              </div>
            </div>
            <div className="col-6 py-3">
              <div className="f10-400 opacity5 pb-2">Pont of Entry</div>
              <div className="f12-500 c_black">-</div>
            </div>
          </div>
          <div className="sectionHeader border-top-0 d-flex align-items-center justify-content-between f12-700">
            <span>View Audit Log</span>
            <Image
              src={require("../../../assets/images/UserManagement/up-arrow.svg")}
              alt="offer"
              title="offer"
              fluid
              width="15px"
              style={{ width: 15 }}
              className={`ml-2 ${!showLog ? "en180deg" : ""}`}
              onClick={handleShowLog}
            />
          </div>
          <div className="">
            {showLog && (
              <Table striped responsive className="mb-0">
                <thead className="audit-table-header">
                  <AuditLogsheaderTable
                    date="Date"
                    operation="Comments"
                    by="Comments By"
                  />
                </thead>
                <tbody>{renderAuditViewDetails()}</tbody>
              </Table>
            )}
          </div>
        </Modal>
      </React.Fragment>
    </>
  );
};

export default MobileViewEventDetailsOffline;
